import React, { useRef, useState } from 'react';
import Select from 'react-select';
import enums from '../../../enums';

const CafeDiscountRequestsFilter = props => {
  const { onSelectCafeIds } = props;
  const formRefrence = useRef();
  const [cafeIds, setCafeIds] = useState([]);
  const [namePart, setNamePart] = useState('');
  const [filters, setFilters] = useState({});

  const onChangeNamePart = event => {
    setNamePart(event.target.value);
    let clonedFilters = { ...filters };
    clonedFilters.namePart = {
      operator: ''
    };
    setFilters(clonedFilters);
  };

  const onChangeCafeIds = selectedCafeIds => {
    setCafeIds(selectedCafeIds);
    onSelectCafeIds(selectedCafeIds);
  };

  const resetForm = event => {
    Array.from(formRefrence.current).forEach(element => {
      if (element.type === 'radio' || element.type === 'checkbox') {
        element.checked = null;
      } else if (element.name === 'resetButton') {
        element.value = locales('fields.reset');
      } else {
        element.value = null;
      }
    });
    setCafeIds([]);
    onSelectCafeIds([]);
    setNamePart('');
    props.applyFilters(event);
  };

  return (
    <article>
      <form
        ref={formRefrence}
        onReset={event => resetForm(event)}
        onSubmit={event => {
          props.applyFilters(event);
        }}
        id="filterForm"
        className="card card my-4"
      >
        <header className="text-center card-header">
          <h5 className="font-italic text-muted">{locales('titles.filter')}</h5>
        </header>
        <main className="card-body">
          <div className="d-flex justidy-content-between px-1">
            <div className="d-flex flex-column col-3 h-50 mx-1">
              <input
                onChange={onChangeNamePart}
                value={namePart}
                name="namePart"
                type="text"
                className="form-control col-12"
                placeholder={locales('tables.title')}
                maxLength={enums.MAX_LENGTH.fullName}
              />
              <small style={{ color: '#ccc' }}>{locales('maxLength.50')}</small>
            </div>
            <div className="d-flex flex-column col-4 h-50 mx-1">
              <Select
                id="cafeIds"
                name="cafeIds"
                isMulti={true}
                value={cafeIds}
                onChange={onChangeCafeIds}
                className="col-12"
                options={props.cafeNamesList.map(n => ({
                  label: n.name,
                  value: n.id
                }))}
                placeholder={locales('fields.cafe.name')}
              />
            </div>
          </div>

          <div className="col-12 d-flex justify-content-end p-0">
            <input
              name="resetButton"
              type="reset"
              value={locales('fields.reset')}
              className="btn btn-danger w-5 mx-2"
            />
            <button
              type="submit"
              id="apply-filter-btn-cafeEvent-requesteds"
              className="btn btn-success w-5 mx-2"
            >
              {locales('fields.applyFilters')}
            </button>
          </div>
        </main>
      </form>
    </article>
  );
};

export default CafeDiscountRequestsFilter;
